import { IAppState } from '../../common/state';
import { INewbuildingLayout } from '../../types/residentialComplexLayouts/layouts/newbuildingLayout';

export const residentialComplexLayoutsSelector = (state: IAppState): INewbuildingLayout[] | null => {
  return state.newbuildingLayouts;
};
